import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QueryParamsService } from '@services/query-params/query-params.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.sass'],
})
export class PaginationComponent implements OnInit, OnDestroy {
  public currentPage = 1;
  @Input() public count = 0;
  @Input() public pageSize = 10;
  private qpSub?: Subscription;

  constructor(
    private _route: ActivatedRoute,
    private _qpService: QueryParamsService
  ) {}

  ngOnInit(): void {
    this.qpSub = this._route.queryParams.subscribe(qp => {
      this.checkAndUpdatePage(+qp.page);
    });
  }

  getPageCount(): number | null {
    if (this.count > 0) {
      return Math.ceil(this.count / this.pageSize);
    }
    return null;
  }

  next(): void {
    this.currentPage += 1;
    this.updateQp();
  }

  prev(): void {
    this.currentPage -= 1;
    this.updateQp();
  }

  updateQp(): void {
    this._qpService.changeQueryParams({ page: this.currentPage });
  }

  checkAndUpdatePage(page: number): void {
    if (page < 1) {
      this.currentPage = 1;
      this.updateQp();
    } else {
      this.currentPage = page || 1;
    }
  }

  ngOnDestroy(): void {
    this.qpSub?.unsubscribe();
  }
}
